module.exports = __webpack_public_path__ + "assets/Tangent.f5e03a840ddd10a1413d9eb3f31acfb1.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Tangent.gmt
// module id = 1016
// module chunks = 0